import { useTranslation } from 'react-i18next';
import { toLocaleString } from '../../lib/currency-helpers.ts';
import { useResolvedLocale } from '../../lib/hooks/locale.ts';
import { Button } from '../ui/button.tsx';
import SmallSpinner from '../ui/small-spinner.tsx';

type Props = {
    loading: boolean;
    count?: number;
    actionText?: string;
    onAction?: () => void;
};

export function TableFooter({ loading, count, actionText, onAction }: Props) {
    const { t } = useTranslation();
    const locale = useResolvedLocale();

    const actionTextParsed = actionText || t('table_more_results');

    return (
        <div className="mt-3 flex w-full flex-row items-center justify-start ">
            {/* <div className="font-base text-sm flex flex-1 leading-3">
                {`${count ? toLocaleString(count, locale) : count} ${
                    count === 1 ? t('table_count_results_singular') : t('table_count_results_plural')
                }`}
            </div> */}

            <div className="font-base flex flex-1 text-left text-sm leading-3">
                {!Number.isNaN(count) && !loading ? (
                    <span className="mr-1">{toLocaleString(Number(count), locale)}</span>
                ) : (
                    <div className="mr-1 flex items-center justify-center">
                        <SmallSpinner />
                    </div>
                )}
                {count === 1 ? t('table_count_results_singular') : t('table_count_results_plural')}
            </div>

            <div className="flex flex-1 items-center justify-center">
                {onAction && (
                    <Button variant="subtle" onClick={onAction} disabled={!onAction}>
                        {actionTextParsed}
                    </Button>
                )}
            </div>
            <div className="flex flex-1" />
        </div>
    );
}
